<template>
  <div id="seasons">
    <!-- Seasons Filter -->
    <b-form-input
      type="text"
      placeholder="Filter Seasons"
      ref="filterSeasons"
      v-model="filter">
    </b-form-input>
    <!-- / Seasons Filter -->

    <!-- Seasons Table -->
    <b-table
      striped
      hover
      selectable
      stacked="lg"
      small
      show-empty
      select-mode="single"
      sort-by="timestamp_start_date_time"
      @row-selected="goToSeason"
      :items="filteredSeasons"
      :fields="fields"
      empty-text="No Seasons to show.">
      <template
        slot="timestamp_start_date_time"
        slot-scope="{ item }">
        {{item.display_start_date_time}}
      </template>
      <template
        slot="timestamp_end_date_time"
        slot-scope="{ item }">
        {{item.display_end_date_time}}
      </template>
    </b-table>
    <!-- / Seasons Table -->

    <!-- Create Season Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      @click="$router.push({ name: 'season', params: { seasonID: 'new' } })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Create New Season
    </b-button>
    <!-- / Create Season Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/app-mixin';

export default {
  name: 'seasons',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      filter: '',
      fields: [
        {
          key: 'name',
          label: 'Season',
          sortable: true,
        },
        {
          key: 'timestamp_start_date_time',
          label: 'Start',
          sortable: true,
        },
        {
          key: 'timestamp_end_date_time',
          label: 'End',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    filteredSeasons() {
      return _.filter(
        this.seasons,
        o => o.name.toLowerCase().includes(this.filter.toLowerCase()),
      );
    },
  },
  methods: {
    goToSeason(selected) {
      const [o] = selected;
      this.$router.push({
        name: 'season',
        params: { seasonID: o.id },
      });
    },
  },
  created() {
    this.showGlobalLoader('Loading seasons...');
    this.initPromise.finally(this.hideGlobalLoader);
  },
};
</script>

<style lang="scss"></style>
